import { useCallback } from 'react'

import { preventDefault, stopPropagation } from '../../../../utils/events'

import { INTERACTIVE_KEYS } from './useTagInteractiveHandlers.constants'

export function useTagInteractiveHandlers({ isDisabled, onClick }) {
  const handleClick = useCallback(
    e => {
      if (!isDisabled && onClick) {
        stopPropagation(e)
        onClick(e)
      }
    },
    [isDisabled, onClick]
  )

  const handleKeyDown = useCallback(
    e => {
      if (!isDisabled && onClick && INTERACTIVE_KEYS.has(e.key)) {
        preventDefault(e)
        stopPropagation(e)
        onClick(e)
      }
    },
    [isDisabled, onClick]
  )

  return { handleClick, handleKeyDown }
}
